import axios from "axios";

export const globalAxios = axios.create({
    baseURL: process.env.REACT_APP_MAIN_BACKEND_URL,
    headers: {
        'Authorization': `Bearer ${process.env.REACT_APP_MAIN_BACKEND_TOKEN}`
    }
})
